import React from 'react';
import CompleteModal from "./complete-modal";

const LessonComplete = ({onRestudy, onNext, onExit, onSubmit, onClose}) => {
    return <CompleteModal
        title={window.L('teach.lesson.currentComplete')}
        nextTitle={window.L('teach.lesson.nextLesson')}
        restudyTitle={window.L('teach.lesson.restudy')}
        exitTitle={window.L('teach.lesson.exit')}
        onRestudy={onRestudy}
        onNext={onNext}
        onExit={onExit}
        onSubmit={onSubmit}
        onClose={onClose}
        // finish
    />
}

export default LessonComplete;
